module.exports = __webpack_public_path__ + "img/spotlight.046904ce.svg";